import { Sliders, Users, LogOut, Home, MessageSquare, Smartphone, Search, FileText, Calendar as CalendarIcon, Server, AtSign, TrendingUp, Bell, Shield, PieChart, Send, User, UserCheck, Award, Pocket, BarChart2, Tool, Calendar, DollarSign, Layers, CreditCard, Key, Tablet, Flag, Folder, File, Zap, Clipboard } from "react-feather";

import { AddModeratorOutlined, AvTimerOutlined, CampaignOutlined, DirectionsCarFilledOutlined, EventRepeatOutlined, LocalOfferOutlined, ManageAccountsOutlined } from "@mui/icons-material";

/*const HomeDefault = async(() => import("../pages/home/home"));
const Blogs = async(() => import("../pages/blogs/blogs"));
const ContactUs = async(() => import("../pages/contactus/contactus"));
const Privacy = async(() => import("../pages/privacy/privacy"));
const EULA = async(() => import("../pages/eula/eula"));

const RentalApplication = async(() => import("../pages/rental-application/rental-application"));
const RentalApplication2 = async(() => import("../pages/rental-application/rental-application-2"));
const RentalApplicationApplication2 = async(() => import("../pages/rental-application/rental-application-application-2"));
const RentalApplicationSuccess = async(() => import("../pages/rental-application/rental-application-success"));
const RentalApplicationError = async(() => import("../pages/rental-application/rental-application-error"));
const RentalApplicationInvalid = async(() => import("../pages/rental-application/rental-application-invalid"));
const RentalApplicationalreadySubmitted = async(() => import("../pages/rental-application/rental-application-already-subimitted"));
const RentalApplicationaLinkExpired = async(() => import("../pages/rental-application/rental-application-link-expired"));
const RentalApplicationPayment = async(() => import("../pages/rental-application/rental-application-payment"));

const AdminIndex = async(() => import("../pages/admin/index"));
const Dashboard = async(() => import("../pages/dashboards/Default"));
const Properties = async(() => import("../pages/properties/properties"));
const PropertiesDetails = async(() => import("../pages/properties/propertydetails"));
const UserList = async(() => import("../pages/users/userlist"));
const TenantList = async(() => import("../pages/tenants/tenantlist"));
const TenantDetails = async(() => import("../pages/tenants/tenantdetails"));
const MaintenanceRequest = async(() => import("../pages/maintenancerequest/maintenancerequest"));
const MaintenanceRequestAdd = async(() => import("../pages/maintenancerequest/maintenancerequestadd"));
const MaintenanceRequestDetails = async(() => import("../pages/maintenancerequest/maintenancerequestdetails"));
const Complaints = async(() => import("../pages/complaints/complaints"));
const ComplaintsAdd = async(() => import("../pages/complaints/complaintsadd"));
const ComplaintsDetails = async(() => import("../pages/complaints/complaintsdetails"));
const Violations = async(() => import("../pages/violations/violations"));
const ViolationsAdd = async(() => import("../pages/violations/violationsadd"));
const ViolationsDetails = async(() => import("../pages/violations/violationsdetails"));
const Communication = async(() => import("../pages/communication/communication"));
const CommunicationProspect = async(() => import("../pages/communication-prospect/communication-prospect"));
const Leases = async(() => import("../pages/payment/Leases"));
const LeaseDetails = async(() => import("../pages/payment/LeaseDetails"));
const LeaseSignSuccessAdmin = async(() => import("../pages/payment/LeaseSignSuccessAdmin"));
const LeaseSignSuccessTenant = async(() => import("../pages/payment/LeaseSignSuccessTenant"));
const AddLeaseDocumentSuccess = async(() => import("../pages/payment/AddLeaseDocumentSuccess"));
const AddLeaseTemplateSuccess = async(() => import("../pages/payment/AddLeaseTemplateSuccess"));
const EditLeaseTemplateSuccess = async(() => import("../pages/payment/EditLeaseTemplateSuccess"));
const AddLease = async(() => import("../pages/payment/AddLease"));
const RenewLease = async(() => import("../pages/payment/RenewLease"));
const RentRoll = async(() => import("../pages/payment/RentRoll"));
const RentRollDetails = async(() => import("../pages/payment/RenRollDetails"));
const AddCredit = async(() => import("../pages/payment/AddCredit"));
const AddBill = async(() => import("../pages/payment/AddBill"));
const RecordPayment = async(() => import("../pages/payment/RecordPayment"));
const UpdateCredit = async(() => import("../pages/payment/AddCredit"));
const UpdateBill = async(() => import("../pages/payment/AddBill"));
const UpdatePayment = async(() => import("../pages/payment/RecordPayment"));
const SmartDevices = async(() => import("../pages/smartdevices/smartdevices"));
const SmartDevicesDetails = async(() => import("../pages/smartdevices/smartdevicedetails"));
//const SmartdeviceFloorMap = async(() => import("../pages/smartdevices/smartdevicefloormap"));
const SmartDevicesAlerts = async(() => import("../pages/smartdevices/smart-devices-alerts/smart-device-alerts"));
const Logs = async(() => import("../pages/logs/logs"));
const More = async(() => import("../pages/more/more"));
const LogOff = async(() => import("../pages/logoff/LogOff"));
const Notifications = async(() => import("../pages/notification/notifications"));
const PayNow = async(() => import("../pages/paynow/paynow"));
const PaymentSuccess = async(() => import("../pages/paynow/pay-success"));

const ProspectDetails = async(() => import("../pages/prospect/prospectdetails"));
const ScheduleTour = async(() => import("../pages/schedule-tour/tour"));*/

import HomeDefault from "../pages/home/home";
import Blogs from "../pages/blogs/blogs";
import ContactUs from "../pages/contactus/contactus";
import Privacy from "../pages/privacy/privacy";
import EULA from "../pages/eula/eula";

import RentalApplication from "../pages/rental-application/rental-application";
import RentalApplication2 from "../pages/rental-application/rental-application-2";
import RentalApplicationApplication2 from "../pages/rental-application/rental-application-application-2";
import RentalApplicationSuccess from "../pages/rental-application/rental-application-success";
import RentalApplicationSuccess2 from "../pages/rental-application/rental-application-success-2";
import RentalApplicationSuccess3 from "../pages/rental-application/rental-application-noapt-success";
import RentalApplicationError from "../pages/rental-application/rental-application-error";
import RentalApplicationInvalid from "../pages/rental-application/rental-application-invalid";
import RentalApplicationalreadySubmitted from "../pages/rental-application/rental-application-already-subimitted";
import RentalApplicationaLinkExpired from "../pages/rental-application/rental-application-link-expired";
import RentalApplicationPayment from "../pages/rental-application/rental-application-payment";

import UserVerification from "../pages/users/verification/verify";
import ProspectVerification from "../pages/prospect/verification/verify";
import ProspectVerificationInvalid from "../pages/prospect/verification/invalid-link";

import ProspectConnectBank from "../pages/prospect/connect/connect";
import ProspectConnectBankInvalid from "../pages/prospect/connect/connect-invalid-link";
import ProspectConnectBankSuccess from "../pages/prospect/connect/connect-success";
import ProspectConnectBankCancel from "../pages/prospect/connect/connect-cancel";
import ProspectConnectBankError from "../pages/prospect/connect/connect-error";

//import RescheduleTour from "../pages/prospect/reschedule/reschedule";
//import RescheduleInvalid from "../pages/prospect/reschedule/reschedule-invalid-link";
//import RescheduleSuccess from "../pages/prospect/reschedule/reschedule-success";
//import RescheduleCancel from "../pages/prospect/reschedule/reschedule-cancel";

//import ScheduleTourPublic from "../pages/prospect/schedule/schedule";
//import SchedulePublicInvalid from "../pages/prospect/schedule/schedule-invalid-link";
//import SchedulePublicSuccess from "../pages/prospect/schedule/schedule-success";
//import SchedulePublicCancel from "../pages/prospect/schedule/schedule-cancel";

import LeaseExtensionForm from "../pages/tenants/components/leaseextensionform/leaseextensionform";
import LeaseExtensionFormExpired from "../pages/tenants/components/leaseextensionform/leaseextensionform-expired";
import LeaseExtensionFormInvalid from "../pages/tenants/components/leaseextensionform/leaseextensionform-invalid";
import LeaseExtensionFormSuccess from "../pages/tenants/components/leaseextensionform/leaseextensionform-success";

import AdminIndex from "../pages/admin/index";
import Login from "../pages/login/Login"
import Dashboard from "../pages/dashboards/Default";
import LeaseRenewalDashbord from "../pages/lease-renewal/dashboard/dashboard";
import CreditReportDashbord from "../pages/credit-report/creditreport";
import UserTileTracking from "../pages/user-time-tracking/UserTimeTracking";
import Properties from "../pages/properties/properties";
import PropertiesDetails from "../pages/properties/propertydetails";
import PropertyLeaseTemplateAdd from "../pages/properties/AddLeaseTemplate"
import UserList from "../pages/users/userlist";
import UserRoles from "../pages/roles/roles";
import ContactList from "../pages/contactlists/contactlists";
import TenantList from "../pages/tenants/tenantlist";
import TenantDetails from "../pages/tenants/tenantdetails";
import MaintenanceRequest from "../pages/maintenancerequest/maintenancerequest";
import MaintenanceRequestDetails from "../pages/maintenancerequest/maintenancerequestdetails";
import Complaints from "../pages/complaints/complaints";
import ComplaintsDetails from "../pages/complaints/complaintsdetails";
//import Violations from "../pages/violations/violations";
import ViolationsAdd from "../pages/violations/violationsadd";
import ViolationsDetails from "../pages/violations/violationsdetails";
import Communication from "../pages/communication/communication";
import CommunicationProspect from "../pages/communication-prospect/communication-prospect";
//import Leases from "../pages/payment/Leases";
import Leases from "../pages/leases/Leases";
import LeaseDetails from "../pages/payment/LeaseDetails";
//import LeaseSignSuccessAdmin from "../pages/payment/LeaseSignSuccessAdmin";
//import LeaseSignSuccessTenant from "../pages/payment/LeaseSignSuccessTenant";
//import AddLeaseDocumentSuccess from "../pages/payment/AddLeaseDocumentSuccess";
//import AddLeaseTemplateSuccess from "../pages/payment/AddLeaseTemplateSuccess";
//import EditLeaseTemplateSuccess from "../pages/payment/EditLeaseTemplateSuccess";
//import AddLease from "../pages/payment/AddLease";
//import RenewLease from "../pages/payment/RenewLease";
//import RentRoll from "../pages/payment/RentRoll";
//import RentRollDetails from "../pages/payment/RenRollDetails";
import SmartDevices from "../pages/smartdevices/smartdevices";
import SmartDevicesDetails from "../pages/smartdevices/smartdevicedetails";
import SmartDevicesAlerts from "../pages/smartdevices/smart-devices-alerts/smart-device-alerts";
import Logs from "../pages/logs/logs";
import More from "../pages/more/more";
import LogOff from "../pages/logoff/LogOff";
import Notifications from "../pages/notification/notifications";
import PayNow from "../pages/paynow/paynow";
import AppPayNow from "../pages/paynow/apppaynow";
import AppPayNowNew from "../pages/paynow/apppay/AppPay";
import PaymentSuccess from "../pages/paynow/pay-success";
import TenantPaySuccess from "../pages/paynow/tenant-pay-success";
import TabletPaySuccess from "../pages/paynow/tablet-pay-success";

import ProspectDetails from "../pages/prospect/prospectdetails";
import LeaderBoard from "../pages/prospect/leaderboard/leaderboard";
import ScheduleTour from "../pages/schedule-tour/tour";
import KnowledgeBase from "../pages/resources/articles/articles";
import AddArticle from "../pages/resources/articles/components/addArticle"
import KnowledgeBaseCategory from "../pages/resources/articles/categories/article-category";
import CommunityBoard from "../pages/resources/alerts/alerts";
import AddCommunityBoard from "../pages/resources/alerts/components/addAlert"
import ManageGroups from "../pages/emailcampaigns/groups/Groups";
import ManageCampaigns from "../pages/emailcampaigns/campaigns/Campaigns";
import EmailLogs from "../pages/emailcampaigns/logs/Logs";
import EmailLogsDetails from "../pages/emailcampaigns/logs/LogDetails";
import RenewalOffers from "../pages/lease-renewal/offer-templates/templates";
import AddRenewalOffer from "../pages/lease-renewal/offer-templates/components/addTemplate/TemplateAdd";
import ViewRenewalOffer from "../pages/lease-renewal/offer-templates/components/previewTemplate/PreviewTemplate";
import GroupContacts from "../pages/emailcampaigns/groups/components/conatactlist/ContactList";
import AddCampaigns from "../pages/emailcampaigns/campaigns/components/AddEmailCampaign";
import CampaignsPreview from "../pages/emailcampaigns/campaigns-preview/CampaignsPreview";
import TenantConnectBank from "../pages/tenants/connect/connect";
import AllIncome from "../pages/income/all-income/AllIncome";
import IncomeCategory from "../pages/income/income-category/IncomeCategory";
import IncomeGridDetails from "../pages/income/all-income/components/income-grid/income-grid-details/IncomeGridDetails";
import ExpenseCategory from "../pages/expense/expense-category/ExpenseCategory";


import ExpensePayee from "../pages/expense/expense-payee/ExpensePayee";
import AllExpense from "../pages/expense/all-expense/AllExpense";
import AddExpense from "../pages/expense/all-expense/components/expense-list/components/AddExpense";

import Keyfobs from "../pages/smartdevices/keyfob/Keyfobs";
import IotAccounts from "../pages/smartdevices/iotaccounts/AccountList";
import KeyfobDetails from "../pages/smartdevices/keyfob/KeyfobDetails";
import ProspectMain from "../pages/prospect/ProspectMain";

import Vehicles from "../pages/vehicles/Vehicles";
import VehicleLinkRequest from "../pages/vehicles/public/VehicleLinkRequest";
import TenantVehiclePortal from "../pages/vehicles/public/TenantVehiclePortal";
import GuestVehicle from "../pages/vehicles/public/GuestVehicle";
import { GuestVehicleSuccess, GuestVehicleCancelled } from "../pages/vehicles/public/GuestVehicleResult";
import GuestAccess from "../pages/vehicles/public/GuestAccess";
import Journals from "../pages/security-journal/Journal";
import JournalDetails from "../pages/security-journal/components/details/JournalDetails";
import TaskList from "../pages/tasks/TaskList";
import TechnicianTaskList from "../pages/tasks/TechnicianTasks/TaskList";
//import TechnicianMaintenanceRequests from "../pages/maintenancerequest/technician-maintenance-requests/TechnicianMaintenanceRequests";
import PetsOutlinedIcon from '@mui/icons-material/PetsOutlined';
import Pets from "../pages/pets/Pets";
import EmailSMSNotification from "../pages/emailSmsNotification/notification";
import AddEmailNotification from "../pages/emailSmsNotification/addNotification";
import PreviewNotification from "../pages/emailSmsNotification/notificationDetails";
import RentrollReports from "../pages/reports/rentrollreport/RentrollReport";
import PinataReports from "../pages/reports/pinatareport/PinataReport";

import TenantOffer from "../pages/lease-renewal/offer/TenantOffer";
import TenantOfferAccept from "../pages/lease-renewal/offer/TenantOfferAccept";
import TenantOfferUnsure from "../pages/lease-renewal/offer/TenantOfferUnsure";
import LeaseSign from "../pages/lease-renewal/lease-sign/LeaseSign";
import LeaseSignSuccess from "../pages/lease-renewal/lease-sign/LeaseSignSuccess";
//import GuestPass from "../pages/vehicles/components/payment/GuestPassPage";
//import GuestPassSuccess from "../pages/vehicles/components/payment/GuestPassSuccessPage";
//import GuestPassCancelled from "../pages/vehicles/components/payment/GuestPassCancelledPage";
//import GuestPassInvalid from "../pages/vehicles/components/payment/GuestPassInvalid"

//import Inspections from "../pages/Inspection/Inspection";

const indexRoutes = {
  path: "/",
  component: HomeDefault,
};
const homeRoutes = {
  path: "/home",
  component: HomeDefault,
};
const blogsRoutes = {
  path: "/blogs",
  component: Blogs,
};
const contactUsRoutes = {
  path: "/contact-us",
  component: ContactUs,
};
const privacyRoutes = {
  path: "/privacy-policy",
  component: Privacy,
};
const eulaRoutes = {
  path: "/eula",
  component: EULA,
};
const RentalApplicationRoutesFront = {
  path: "/rental-application/:str",
  component: RentalApplication,
};
const RentalApplication2RoutesFront = {
  path: "/rental-application/re-application/:appStr/:str",
  component: RentalApplication2,
};
const RentalApplicationApplication2RoutesFront = {
  path: "/rental-application/application-2/:str",
  component: RentalApplicationApplication2,
};

const RentalApplicationSuccessRoutesFront = {
  path: "/rental-application-success/:id",
  component: RentalApplicationSuccess,
};
const RentalApplicationSuccessRoutesFront2 = {
  path: "/rental-application-success/:id/:id2",
  component: RentalApplicationSuccess2,
};
const RentalApplicationNoaptSuccessRoutes = {
  path: "/rental-application-success-noapt/:str",
  component: RentalApplicationSuccess3,
};
const RentalApplicationErrorRoutes = {
  path: "/rental-application-error/:id",
  component: RentalApplicationError,
};
const RentalApplicationInvalidRoutes = {
  path: "/rental-application-invalid",
  component: RentalApplicationInvalid,
};
const RentalApplicationalreadySubmittedRoutes = {
  path: "/rental-application-already-submitted/:id",
  component: RentalApplicationalreadySubmitted,
};
const RentalApplicationLinkExpiredRoutes = {
  path: "/rental-application-link-expired/:id",
  component: RentalApplicationaLinkExpired,
};
const RentalApplicationPaymentRoutes = {
  path: "/rental-application-payment/:str",
  component: RentalApplicationPayment,
};

//User Verification
const UserVerificationRoutes = {
  path: "/user-verify/:str",
  component: UserVerification,
}

//Prospect Verification
const ProspectVerificationRoutes = {
  path: "/verify/:str",
  component: ProspectVerification,
};

const ProspectVerificationInvalidRoutes = {
  path: "/verify-invalid",
  component: ProspectVerificationInvalid,
};

const ProspectConnectBankRoutes = {
  path: "/connect/:str",
  component: ProspectConnectBank,
};

const ProspectConnectBankInvalidRoutes = {
  path: "/connect-invalid",
  component: ProspectConnectBankInvalid,
};

const ProspectConnectBankSuccessRoutes = {
  path: "/connect-success/:str",
  component: ProspectConnectBankSuccess,
};

const ProspectConnectBankErrorRoutes = {
  path: "/connect-error/:str",
  component: ProspectConnectBankError,
};

const ProspectConnectBankCancelRoutes = {
  path: "/connect-cancel/:str",
  component: ProspectConnectBankCancel,
};

const TenantConnectBankRoutes = {
  path: "/tenant/bank-connect/:str",
  component: TenantConnectBank,
};

/*const RescheduleTourRoutes = {
  path: "/reschedule/:str",
  component: RescheduleTour,
};

const RescheduleInvalidRoutes = {
  path: "/reschedule-invalid",
  component: RescheduleInvalid,
};

const RescheduleSuccessRoutes = {
  path: "/reschedule-success/:str",
  component: RescheduleSuccess,
};

const RescheduleCancelRoutes = {
  path: "/reschedule-cancel/:str",
  component: RescheduleCancel,
};


const ScheduleTourPublicRoutes = {
  path: "/schedule/:str",
  component: ScheduleTourPublic,
};

const SchedulePublicInvalidRoutes = {
  path: "/schedule-invalid",
  component: SchedulePublicInvalid,
};

const SchedulePublicSuccessRoutes = {
  path: "/schedule-success/:str",
  component: SchedulePublicSuccess,
};

const SchedulePublicCancelRoutes = {
  path: "/schedule-cancel/:str",
  component: SchedulePublicCancel,
};*/

const LeaseExtensionFormRoutes = {
  path: "/lease-extension-form/:str",
  component: LeaseExtensionForm,
};

const LeaseExtensionFormInvalidRoutes = {
  path: "/lease-extension-form-invalid",
  component: LeaseExtensionFormInvalid,
};

const LeaseExtensionFormExpiredRoutes = {
  path: "/lease-extension-form-expired/:str",
  component: LeaseExtensionFormExpired,
};

const LeaseExtensionFormSuccessRoutes = {
  path: "/lease-extension-form-success/:str",
  component: LeaseExtensionFormSuccess,
};

//Tenant Offer
const tenantOfferRoutes = {
  path: "/renewal-offer/:str",
  component: TenantOffer,
};

const tenantOfferAcceptRoutes = {
  path: "/renewal-offer-accept/:str",
  component: TenantOfferAccept,
};

const tenantOfferUnsureRoutes = {
  path: "/renewal-offer-unsure/:str",
  component: TenantOfferUnsure,
};

const leaseSignRoutes = {
  path: "/lease-sign/:str",
  component: LeaseSign,
};

const leaseSignSuccessRoutes = {
  path: "/lease-sign-success/:str",
  component: LeaseSignSuccess,
};

/*const guestPassRoutes = {
  path: "/guest-pass/:uuid",
  component: GuestPass,
};

const guestPassSuccessRoutes = {
  path: "/guest-pass/:uuid/success",
  component: GuestPassSuccess,
};

const guestPassCancelledRoutes = {
  path: "/guest-pass/:uuid/cancelled",
  component: GuestPassCancelled,
};

const guestPassInvalidRoutes = {
  path: "/guest-pass/:uuid/invalid",
  component: GuestPassInvalid,
};*/

// Public vehicle request pages (tenant update link and guest vehicle invite)
const vehicleLinkRequestRoutes = {
  path: "/vehicle-update",
  component: VehicleLinkRequest,
};

const tenantVehiclePortalRoutes = {
  path: "/vehicle-update/:token",
  component: TenantVehiclePortal,
};

const guestVehicleRoutes = {
  path: "/guest-vehicle/:token",
  component: GuestVehicle,
};

const guestVehicleSuccessRoutes = {
  path: "/guest-vehicle/:token/success",
  component: GuestVehicleSuccess,
};

const guestVehicleCancelledRoutes = {
  path: "/guest-vehicle/:token/cancelled",
  component: GuestVehicleCancelled,
};

// Public guest parking access page (gate / door controls), texted to the guest when the pass starts
const guestAccessRoutes = {
  path: "/a/:token",
  component: GuestAccess,
};

const adminIndexRoutes = {
  id: "AdminIndex",
  path: "/admin",
  icon: <Sliders />,
  component: AdminIndex,
  children: null,
  permission: ["all:list"],
  alternatePaths: ["/dashboard"],
};

/*const dashboardsRoutesOld = {
  id: "Dashboard",
  path: "/dashboard",
  icon: <Sliders />,
  component: Dashboard,
  children: null,
  permission: ["dashboard:read"],
  alternatePaths: ["/dashboard"],
};*/

const dashboardsRoutes = {
  id: "Dashboard",
  path: "/dashboard",
  icon: <Sliders />,
  permission: ["dashboard:read", "dashboard-leaserenewal:read", "dashboard-creditreport:read"],
  alternatePaths: ["/dashboard/overview", "/dashboard/lease-renewal", "/dashboard/credit-report"],
  children: [
    {
      path: "/dashboard/overview",
      name: "Overview",
      component: Dashboard,
      permission: ["dashboard:read"],
      alternatePaths: ["/dashboard/overview"],
    },
    {
      path: "/dashboard/lease-renewal",
      name: "Lease Renewal",
      component: LeaseRenewalDashbord,
      permission: ["dashboard-leaserenewal:read"],
      alternatePaths: ["/dashboard/lease-renewal"],
    },
    {
      path: "/dashboard/credit-report",
      name: "Credit to Wealth Report",
      component: CreditReportDashbord,
      permission: ["dashboard-creditreport:read"],
      alternatePaths: ["/dashboard/credit-report"],
    }
  ],
  component: null,
};


const propertiesRoutes = {
  id: "Properties",
  path: "/properties/list",
  icon: <Home />,
  component: Properties,
  children: null,
  permission: ["property:read"],
  alternatePaths: ["/properties/list", "/properties/details/"],
}

const propertiesDetRoutes = {
  id: "PropertiesDetails",
  path: "/properties/details/:id",
  icon: <Home />,
  component: PropertiesDetails,
  children: null,
  permission: ["property:read"],
}

const propertyLeaseTemplateAddRoutes = {
  id: "PropertyLeaseTemplateAdd",
  path: "/properties/:property_id/add-template",
  icon: <Home />,
  component: PropertyLeaseTemplateAdd,
  children: null,
  permission: ["property-leasetemplate:create"],
};
const propertyLeaseTemplateEditRoutes = {
  id: "PropertyLeaseTemplateEdit",
  path: "/properties/:property_id/edit-template/:id",
  icon: <Home />,
  component: PropertyLeaseTemplateAdd,
  children: null,
  permission: ["property-leasetemplate:update"],
};

const peopleRoutes = {
  id: "People",
  path: "/people",
  icon: <Users />,
  permission: ["leaderboard:read", "prospect:read", "tenant:read", "user:read", "emailcontact:read"],
  alternatePaths: ["/people/prospects", "/people/prospects/details/", "/people/prospects/leaderboards", "/people/leaderboards", "/people/tenants", "/people/tenants/details/", "/people/contacts"],
  children: [
    {
      path: "/people/leaderboards",
      name: "Leaderboard",
      component: LeaderBoard,
      permission: ["leaderboard:read"],
      alternatePaths: ["/people/leaderboards"],
    },
    {
      path: "/people/prospects",
      name: "Prospects",
      component: ProspectMain,
      permission: ["prospect:read"],
      alternatePaths: ["/people/prospects", "/people/prospects/details/", "/people/prospects/leaderboards"],
    },
    {
      path: "/people/tenants",
      name: "Tenants",
      component: TenantList,
      permission: ["tenant:read"],
      alternatePaths: ["/people/tenants", "/people/tenants/details/"],
    },
    {
      path: "/people/contacts",
      name: "Contacts",
      component: ContactList,
      permission: ["emailcontact:read"],
      alternatePaths: ["/people/contacts"],
    },
  ],
  component: null,
};

const hrRoutes = {
  id: "HR",
  path: "/hr",
  icon: <img src="/static/img/hr-icon.png" class="ImageIcon" alt="" />,
  permission: ["role:read", "user:read", "dashboard-usertimetracking:read"],
  alternatePaths: ["/hr/employees", "/hr/user-time-tracker", "/people/roles"],
  children: [
    {
      path: "/people/roles",
      name: "Roles",
      component: UserRoles,
      permission: ["role:read"],
      alternatePaths: ["/people/roles"],
    },
    {
      path: "/hr/user-time-tracker",
      name: "Time Tracker",
      component: UserTileTracking,
      permission: ["dashboard-usertimetracking:read"],
      alternatePaths: ["/hr/user-time-tracker"],
    },
    {
      path: "/hr/employees",
      name: "Employees",
      component: UserList,
      permission: ["user:read"],
      alternatePaths: [
        "/hr/employees",
      ],
    }
  ],
  component: null,
};

const tenantDetailsRoutes = {
  id: "TenantDetails",
  path: "/people/tenants/details/:id",
  icon: <Home />,
  component: TenantDetails,
  children: null,
  permission: ["tenant:read", "tenant-contactinfo:read", "tenant-journey:read"],
};
const prospectDetailsRoutes = {
  id: "ProspectDetails",
  path: "/people/prospects/details/:id",
  icon: <Home />,
  component: ProspectDetails,
  children: null,
  permission: ["prospect:read"],
};

const maintenanceRoutes = {
  id: "Maintenance",
  path: "/maintenance",
  icon: <Tool />,
  permission: ["request:read"],
  alternatePaths: ["/maintenance/request", "/maintenance/request/details/", "/maintenance/inspection"],
  children: [
    {
      path: "/maintenance/request",
      name: "Maintenance",
      component: MaintenanceRequest,
      permission: ["request:read"],
      alternatePaths: ["/maintenance/request", "/maintenance/request/details/"],
    },
    /*{
      path: "/maintenance/inspections",
      name: "Inspection",
      component: Inspections,
      permission: ["request:read"],
      alternatePaths: ["/maintenance/inspection"],
    },*/
  ],
  component: null,
}

const requestRoutes = {
  id: "Request",
  path: "/request",
  icon: <img src="/static/img/requestMenu.png" class="ImageIcon" alt="" />,
  permission: ["request:read", "complaint:read", "task:read", "task-checklist:read"],
  alternatePaths: ["/request/complaints", "/request/complaints/details/", "/request/tasks", "/request/task-list"],
  children: [
    {
      path: "/request/complaints",
      name: "Complaints",
      component: Complaints,
      permission: ["complaint:read"],
      alternatePaths: ["/request/complaints", "/request/complaints/details/"],
    },
    {
      path: "/request/tasks",
      name: "Task Manager",
      component: TaskList,
      permission: ["task:read"],
      alternatePaths: ["/request/tasks"],
    },
    {
      path: "/request/task-list",
      name: "Task List",
      component: TechnicianTaskList,
      permission: ["task-checklist:read"],
      alternatePaths: ["/request/task-list"],
    }
  ],
  component: null,
}

const SecurityRoutes = {
  id: "Security",
  path: "/security",
  icon: <Shield />,
  permission: ["vehicle:read", "journal:read"],
  component: null,
  alternatePaths: ["/security/vehicle/list", "/security/journal/list", "/security/journal/details/"],
  children: [
    {
      path: "/security/vehicle/list",
      name: "Vehicles",
      component: Vehicles,
      permission: ["vehicle:read"],
      alternatePaths: ["/security/vehicle/list"],
    },
    {
      path: "/security/journal/list",
      name: "Journal",
      component: Journals,
      permission: ["journal:read"],
      alternatePaths: ["/security/journal/list", "/security/journal/details/"],
    },
  ],
}

const journalDetailsRoutes = {
  id: "JournalDetails",
  path: "/security/journal/details/:id",
  icon: <Home />,
  component: JournalDetails,
  children: null,
  permission: ["journal:read"],
}

const maintenanceRequestDetRoutes = {
  id: "MaintenanceRequestDetails",
  path: "/maintenance/request/details/:id",
  icon: <Home />,
  component: MaintenanceRequestDetails,
  children: null,
  permission: ["request:read"],
}

const complaintDetRoutes = {
  id: "ComplaintsDetails",
  path: "/request/complaints/details/:id",
  icon: <Home />,
  component: ComplaintsDetails,
  children: null,
  permission: ["complaint:read"],
};

const violationAddRoutes = {
  id: "ViolationsAdd",
  path: "/cases/violations/add",
  icon: <Home />,
  component: ViolationsAdd,
  children: null,
  permission: ["violation:create"],
};
const violationEditRoutes = {
  id: "ViolationsEdit",
  path: "/cases/violations/edit/:id",
  icon: <Home />,
  component: ViolationsAdd,
  children: null,
  permission: ["violation:update"],
};

const violationDetRoutes = {
  id: "ViolationsDetails",
  path: "/cases/violations/details/:id",
  icon: <Home />,
  component: ViolationsDetails,
  children: null,
  permission: ["violation:show"],
};

const CommunicationGroupRoutes = {
  id: "Communication",
  path: "/communication",
  icon: <MessageSquare />,
  permission: ["all:list"],
  component: null,
  children: [
    {
      path: "/tenant",
      name: "tenant",
      component: Communication,
      permission: ["all:list"],
      alternatePaths: ["/tenant"],
    },
    {
      path: "/prospect",
      name: "prospect",
      component: CommunicationProspect,
      permission: ["all:list"],
      alternatePaths: ["/prospect"],
    },
  ],
}


// const communicationRoutes = {
//   id: "Communication",
//   path: "/communication",
//   icon: <MessageSquare />,
//   component: Communication,
//   children: null,
//   permission: [],
//   alternatePaths: ["/communication"],
// };
// const communicationProspectRoutes = {
//   id: "CommunicationProspect",
//   path: "/communication/prospect",
//   icon: <MessageSquare />,
//   component: CommunicationProspect,
//   children: null,
//   permission: [],
//   alternatePaths: ["/communication/prospect"],
// };
const LeaseRoutes = {
  id: "Leases",
  path: "/leases",
  icon: <FileText />,
  component: Leases,
  permission: ["lease:read"],
  children: null,
  alternatePaths: ["/leases", "/leases/details/:id", "/leases/add", "/leases/add/:id", "/leases/renew/:id"],
};

const ScheduleTourRoutes = {
  id: "Schedule",
  path: "/schedule",
  icon: <CalendarIcon />,
  component: ScheduleTour,
  permission: ["openhouse:read", "event:read", "prospect-taskaccount:read"],
  children: null,
  alternatePaths: ["/schedule"],
}

const petsRoutes = {
  id: "Pets",
  path: "/pet/list",
  icon: <PetsOutlinedIcon />,
  component: Pets,
  children: null,
  permission: ["pet:read"],
  alternatePaths: ["/pet/list"],
}

const leaseDetRoutes = {
  id: "leaseDetRoutes",
  path: "/leases/details/:id",
  icon: <Home />,
  component: LeaseDetails,
  children: null,
  permission: ["lease:read"],
}

const smartDevicesRoutes = {
  id: "Smart Devices",
  path: "/smart-devices",
  icon: <Smartphone />,
  permission: ["device:read", "device-keyfob:read", "device-alert:read", "device-iotaccount:read"],
  component: null,
  alternatePaths: ["/smart-devices/list", "/smart-devices/alerts", "/smart-devices/details/", "/smart-devices/keyfobs", "/smart-devices/keyfobs/details/", "smart-devices/iot-accounts"],
  children: [
    {
      path: "/smart-devices/list",
      name: "Manage Devices",
      component: SmartDevices,
      permission: ["device:read"],
      alternatePaths: ["/smart-devices/list", "/smart-devices/details/"],
    },
    {
      path: "/smart-devices/keyfobs",
      name: "Manage Keyfobs",
      component: Keyfobs,
      permission: ["device-keyfob:read"],
      alternatePaths: ["/smart-devices/keyfobs", "/smart-devices/keyfobs/details/"],
    },
    {
      path: "/smart-devices/iot-accounts",
      name: "Manage IoT Account",
      component: IotAccounts,
      permission: ["device-iotaccount:read"],
      alternatePaths: ["/smart-devices/iot-accounts"],
    },
    {
      path: "/smart-devices/alerts",
      name: "Device Alerts",
      component: SmartDevicesAlerts,
      permission: ["device-alert:read"],
      alternatePaths: ["/smart-devices/alerts"],
    },
    /*{
      path: "/smart-devices/floor-map",
      name: "Floor Map",
      component: SmartdeviceFloorMap,
      permission: ["device:read"],
      alternatePaths: ["/smart-devices/floor-map"],
    },*/
  ],
};

const smartDevicesDetRoutes = {
  id: "SmartDevicesDetails",
  path: "/smart-devices/details/:id",
  icon: <Smartphone />,
  component: SmartDevicesDetails,
  children: null,
  permission: ["device:read"],
};

const keyfobDetailsRoutes = {
  id: "KeyfobDetails",
  path: "/smart-devices/keyfobs/details/:id",
  icon: <Smartphone />,
  component: KeyfobDetails,
  children: null,
  permission: ["device-keyfob:read"],
};

const resourcesRoutes = {
  id: "Resources",
  path: "/resources",
  icon: <Server />,
  permission: ["knowledgebase:read", "knowledgebase-category:read"],
  component: null,
  alternatePaths: ["/resources/knowledge-bases", "/resources/knowledge-bases/add", "/resources/knowledge-bases/edit/", "/resources/knowledge-base-categories"],
  children: [
    {
      path: "/resources/knowledge-bases",
      name: "Knowledge Base",
      component: KnowledgeBase,
      permission: ["knowledgebase:read"],
      alternatePaths: ["/resources/knowledge-bases", "/resources/knowledge-bases/add", "/resources/knowledge-bases/edit/"],
    },
    {
      path: "/resources/knowledge-base-categories",
      name: "Knowledge Base Category",
      component: KnowledgeBaseCategory,
      permission: ["knowledgebase-category:read"],
      alternatePaths: ["/resources/knowledge-base-categories"],
    },
  ],
}

const addArticleRoute = {
  id: "addArticleRoute",
  path: "/resources/knowledge-bases/add",
  icon: <Home />,
  component: AddArticle,
  children: null,
  permission: ["knowledgebase:create"],
}

const editArticleRoute = {
  id: "addArticleRoute",
  path: "/resources/knowledge-bases/edit/:id",
  icon: <Home />,
  component: AddArticle,
  children: null,
  permission: ["knowledgebase:update"],
}

const addCommunityBoardRoute = {
  id: "addCommunityBoardRoute",
  path: "/communication/community-boards/add",
  icon: <Home />,
  component: AddCommunityBoard,
  children: null,
  permission: ["communityboard:create"],
}

const editCommunityBoardRoute = {
  id: "addCommunityBoardRoute",
  path: "/communication/community-boards/edit/:id",
  icon: <Home />,
  component: AddCommunityBoard,
  children: null,
  permission: ["communityboard:update"],
}

const incomeRoutes = {
  id: "Income",
  path: "/income",
  icon: <img src="/static/img/bank.png" class="ImageIcon" alt="" />,
  permission: ["income:read", "income-category:read"],
  component: null,
  alternatePaths: ["/income/all-income", "/income/income-category", "/income/all-income/details/:id"],
  children: [
    {
      path: "/income/all-income",
      name: "All Income",
      component: AllIncome,
      permission: ["income:read"],
      alternatePaths: ["/income/all-income", "/income/all-income/details/:id"],
    },
    {
      path: "/income/income-category",
      name: "Income Category",
      component: IncomeCategory,
      permission: ["income-category:read"],
      alternatePaths: ["/income/income-category"],
    },

  ],
};

const incomeRentRollDetailsRoutes = {
  id: "IncomeGridDetails",
  path: "/income/all-income/details/:id",
  icon: <Home />,
  component: IncomeGridDetails,
  children: null,
  permission: ["income:read"],
};

const expenseRoutes = {
  id: "Expenses",
  path: "/expense",
  icon: <TrendingUp />,
  permission: ["expense:read", "expense-category:read", "expense-payee:read"],
  component: null,
  alternatePaths: ["/expense/all-expense", "/expense/expense-category", "/expense/manage-payee", "/expense/all-expense/add", "/expense/all-expense/edit/:id"],
  children: [
    {
      path: "/expense/all-expense",
      name: "All Expenses",
      component: AllExpense,
      permission: ["expense:read"],
      alternatePaths: ["/expense/all-expense", "/expense/all-expense/add", "/expense/all-expense/edit/:id"],
    },
    {
      path: "/expense/expense-category",
      name: "Expense Category",
      component: ExpenseCategory,
      permission: ["expense-category:read"],
      alternatePaths: ["/expense/expense-category"],
    },
    {
      path: "/expense/manage-payee",
      name: "Manage Payee",
      component: ExpensePayee,
      permission: ["expense-payee:read"],
      alternatePaths: ["/expense/manage-payee"],
    },

  ],
};

const addExpenseRoute = {
  id: "addExpenseRoute",
  path: "/expense/all-expense/add",
  icon: <Home />,
  component: AddExpense,
  children: null,
  permission: ["expense:create"],
};

const editExpenseRoute = {
  id: "editExpenseRoute",
  path: "/expense/all-expense/edit/:id",
  icon: <Home />,
  component: AddExpense,
  children: null,
  permission: ["expense:update"],
};

const logsRoutes = {
  id: "Logs",
  path: "/logs",
  icon: <Search />,
  component: Logs,
  children: null,
  permission: ["logs:read"],
  alternatePaths: ["/logs"],
};

const moreRoutes = {
  id: "More",
  path: "/more",
  component: More,
  children: null,
  permission: [],
  alternatePaths: ["/more"],
};

const logoutRoutes = {
  id: "Logout",
  path: "/logout",
  component: LogOff,
  icon: <LogOut />,
  children: null,
  permission: [],
  alternatePaths: ["/logout"],
}

const loginRoutes = {
  id: "Login",
  path: "/login",
  component: Login,
  children: null,
  permission: [],
  alternatePaths: ["/login"],
}

const notificationsRoutes = {
  id: "Notifications",
  path: "/notifications",
  icon: <Search />,
  component: Notifications,
  children: null,
  permission: [],
  alternatePaths: ["/notifications"],
};

const payNowRoutes = {
  path: "/pay/:token",
  component: PayNow,
};

const appPayNowRoutes = {
  path: "/tenant-pay-old/:token",
  component: AppPayNow
}

const appPayNowNewRoutes = {
  path: "/tenant-pay/:token",
  component: AppPayNowNew
}

const paymentSuccessRoutes = {
  path: "/payment-success",
  component: PaymentSuccess,
};

const tenantPaymentSuccessRoutes = {
  path: "/tenant-payment-success",
  component: TenantPaySuccess,
};

const tabletPaymentSuccessRoutes = {
  path: "/tablet-payment-success",
  component: TabletPaySuccess
};

const paymentSuccessOldRoutes = {
  path: "/payment-success/:tenantId/:id",
  component: PaymentSuccess,
};
/*const floorRoutes = {
  path: "/floor",
  component: SmartdeviceFloorMap,
};*/
const alertsRoutes = {
  path: "/alerts",
  component: SmartDevicesAlerts,
};


const campaignRoutes = {
  id: "Communication",
  path: "/communication",
  icon: <CampaignOutlined className="CustomSize" />,
  permission: ["campaign:read", "campaign-group:read", "campaign-analytics:read", "campaign-renewaltemplate:read", "communityboard:read"],
  alternatePaths: ["/communication/campaign-groups", "/communication/campaigns", "/communication/analytics", "/communication/analytics/:id", "/communication/renewal-offers", "/communication/community-boards", "/communication/community-boards/add", "/communication/community-boards/edit/"],
  children: [

    {
      path: "/communication/campaign-groups",
      name: "Manage Email Groups",
      component: ManageGroups,
      permission: ["campaign-group:read"],
      alternatePaths: ["/communication/campaign-groups"]
    },
    {
      path: "/communication/campaigns",
      name: "Manage Campaigns",
      component: ManageCampaigns,
      permission: ["campaign:read"],
      alternatePaths: ["/communication/campaigns"]
    },
    {
      path: "/communication/analytics",
      name: "Email Analytics",
      component: EmailLogs,
      className: "CustomSubMenu",
      permission: ["campaign-analytics:read"],
      alternatePaths: ["/communication/analytics", "/communication/analytics/:id"]
    },
    {
      path: "/communication/renewal-offers",
      name: "Renewal Offers",
      component: RenewalOffers,
      permission: ["campaign-renewaltemplate:read"],
      alternatePaths: ["/communication/renewal-offers"]
    },
    {
      path: "/communication/community-boards",
      name: "Community Board",
      component: CommunityBoard,
      permission: ["communityboard:read"],
      alternatePaths: ["/communication/community-boards", "/communication/community-boards/add", "/communication/community-boards/edit/"],
    },
  ],
  component: null,
};

const addOfferTemplateRoutes = {
  id: "AddCampaigns",
  path: "/communication/renewal-offers/add",
  icon: <Smartphone />,
  component: AddRenewalOffer,
  children: null,
  permission: ["campaign-renewaltemplate:create"],
}

const editOfferTemplateRoutes = {
  id: "EditCampaigns",
  path: "/communication/renewal-offers/edit/:id",
  icon: <Smartphone />,
  component: AddRenewalOffer,
  children: null,
  permission: ["campaign-renewaltemplate:update"],
}

const viewOfferTemplateRoutes = {
  id: "ViewCampaigns",
  path: "/communication/renewal-offers/view/:id",
  icon: <Smartphone />,
  component: ViewRenewalOffer,
  children: null,
  permission: ["campaign-renewaltemplate:read"],
}

const groupContactsRoutes = {
  id: "GroupContacts",
  path: "/communication/campaign-groups/:id",
  icon: <Smartphone />,
  component: GroupContacts,
  children: null,
  permission: ["campaign-group:read"],
}

const addCampaignsRoutes = {
  id: "AddCampaigns",
  path: "/communication/campaigns/add",
  icon: <Smartphone />,
  component: AddCampaigns,
  children: null,
  permission: ["campaign:create"],
}

const editCampaignsRoutes = {
  id: "AddCampaigns",
  path: "/communication/campaigns/edit/:id",
  icon: <Smartphone />,
  component: AddCampaigns,
  children: null,
  permission: ["campaign:update"],
}

const previewCampaignsRoutes = {
  id: "PreviewCampaigns",
  path: "/communication/campaigns/preview/:id",
  icon: <Smartphone />,
  component: CampaignsPreview,
  children: null,
  permission: ["campaign:read"],
}

const emailLogsDetailsRoutes = {
  id: "EmailLogsDetails",
  path: "/communication/analytics/:id",
  component: EmailLogsDetails,
  children: null,
  permission: ["campaign-analytics:read"],
}

const EmailSMSNotificationRoutes = {
  id: "Manage Notification",
  path: "/notification/email-sms-notification",
  icon: <Bell />,
  component: EmailSMSNotification,
  permission: ["emailnotification:read"],
  children: null,
  alternatePaths: ["/notification/email-sms-notification", "/notification/email-sms-notification/add", "/notification/email-sms-notification/view/", "/notification/email-sms-notification/edit/"],
}

const AddEmailNotificationRoutes = {
  id: "Add Notification",
  path: "/notification/email-sms-notification/add",
  icon: <Home />,
  component: AddEmailNotification,
  permission: ["emailnotification:create"],
  children: null,
}

const PreviewNotificationRoutes = {
  id: "Preview Notification",
  path: "/notification/email-sms-notification/view/:id",
  icon: <Home />,
  component: PreviewNotification,
  permission: ["emailnotification:read"],
  children: null,
}

const EditNotificationRoutes = {
  id: "Update Notification",
  path: "/notification/email-sms-notification/edit/:id",
  icon: <Home />,
  component: AddEmailNotification,
  permission: ["emailnotification:update"],
  children: null,
}

const reportRoutes = {
  id: "Reports",
  path: "/reports",
  icon: <img src="/static/img/rentroll-report.png" class="ImageIcon" alt="" />,
  permission: ["report-rentroll:read", "report-pinata:read"],
  alternatePaths: ["/reports/rentroll", "/reports/pinata"],
  children: [
    {
      path: "/reports/rentroll",
      name: "Rent Roll",
      component: RentrollReports,
      permission: ["report-rentroll:read"],
      alternatePaths: ["/reports/rentroll"]
    },
    {
      path: "/reports/pinata",
      name: "Pinata Report",
      component: PinataReports,
      permission: ["report-pinata:read"],
      alternatePaths: ["/reports/pinata"]
    },
  ],
  component: null,
}


// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  adminIndexRoutes,
  dashboardsRoutes,
  propertiesRoutes,
  peopleRoutes,
  hrRoutes,
  campaignRoutes,
  EmailSMSNotificationRoutes,
  groupContactsRoutes,
  addCampaignsRoutes,
  editCampaignsRoutes,
  previewCampaignsRoutes,
  emailLogsDetailsRoutes,
  addOfferTemplateRoutes,
  editOfferTemplateRoutes,
  viewOfferTemplateRoutes,
  maintenanceRoutes,
  requestRoutes,
  violationAddRoutes,
  violationEditRoutes,
  LeaseRoutes,
  addArticleRoute,
  editArticleRoute,
  addCommunityBoardRoute,
  editCommunityBoardRoute,
  incomeRoutes,
  incomeRentRollDetailsRoutes,
  expenseRoutes,
  addExpenseRoute,
  editExpenseRoute,
  smartDevicesRoutes,
  SecurityRoutes,
  petsRoutes,
  resourcesRoutes,
  CommunicationGroupRoutes,
  notificationsRoutes,
  reportRoutes,
  logsRoutes,
  logoutRoutes,
  ScheduleTourRoutes,
  moreRoutes,
  journalDetailsRoutes
];

export const dashboardDetailsLayoutRoutes = [
  propertiesDetRoutes,
  maintenanceRequestDetRoutes,
  complaintDetRoutes,
  violationDetRoutes,
  leaseDetRoutes,
  smartDevicesDetRoutes,
  keyfobDetailsRoutes,
  prospectDetailsRoutes,
  tenantDetailsRoutes,
  propertyLeaseTemplateAddRoutes,
  propertyLeaseTemplateEditRoutes,
  AddEmailNotificationRoutes,
  PreviewNotificationRoutes,
  EditNotificationRoutes
];

export const customLayoutRoutes = [
  indexRoutes,
  homeRoutes,
  blogsRoutes,
  contactUsRoutes,
  payNowRoutes,
  appPayNowRoutes,
  appPayNowNewRoutes,
  paymentSuccessRoutes,
  tenantPaymentSuccessRoutes,
  tabletPaymentSuccessRoutes,
  paymentSuccessOldRoutes,
  alertsRoutes,
  privacyRoutes,
  eulaRoutes,
  RentalApplicationRoutesFront,
  RentalApplication2RoutesFront,
  RentalApplicationApplication2RoutesFront,
  RentalApplicationSuccessRoutesFront,
  RentalApplicationSuccessRoutesFront2,
  RentalApplicationNoaptSuccessRoutes,
  RentalApplicationErrorRoutes,
  RentalApplicationInvalidRoutes,
  RentalApplicationalreadySubmittedRoutes,
  RentalApplicationLinkExpiredRoutes,
  RentalApplicationPaymentRoutes,
  UserVerificationRoutes,
  ProspectVerificationRoutes,
  ProspectVerificationInvalidRoutes,
  ProspectConnectBankRoutes,
  ProspectConnectBankInvalidRoutes,
  ProspectConnectBankSuccessRoutes,
  ProspectConnectBankCancelRoutes,
  ProspectConnectBankErrorRoutes,
  TenantConnectBankRoutes,
  LeaseExtensionFormRoutes,
  LeaseExtensionFormInvalidRoutes,
  LeaseExtensionFormExpiredRoutes,
  LeaseExtensionFormSuccessRoutes,
  tenantOfferRoutes,
  tenantOfferAcceptRoutes,
  tenantOfferUnsureRoutes,
  leaseSignRoutes,
  leaseSignSuccessRoutes,
  /*guestPassRoutes,
  guestPassSuccessRoutes,
  guestPassCancelledRoutes,
  guestPassInvalidRoutes,*/
  vehicleLinkRequestRoutes,
  tenantVehiclePortalRoutes,
  guestVehicleRoutes,
  guestVehicleSuccessRoutes,
  guestVehicleCancelledRoutes,
  guestAccessRoutes,
  loginRoutes
];

// Routes using the Auth layout
export const authLayoutRoutes = [];

// Routes that are protected
export const protectedRoutes = [];

// Routes visible in the sidebar
export const sidebarRoutes = [
  dashboardsRoutes,
  propertiesRoutes,
  peopleRoutes,
  hrRoutes,
  campaignRoutes,
  EmailSMSNotificationRoutes,
  ScheduleTourRoutes,
  maintenanceRoutes,
  requestRoutes,
  LeaseRoutes,
  incomeRoutes,
  expenseRoutes,
  smartDevicesRoutes,
  SecurityRoutes,
  petsRoutes,
  resourcesRoutes,
  reportRoutes,
  logsRoutes,
  logoutRoutes,
];

export const mobileMoreRoutes = [{
  title: 'Dashboard',
  permission: ["dashboard:read", "dashboard-leaserenewal:read", "dashboard-usertimetracking:read"],
  children: [
    {
      path: "/dashboard/overview",
      title: "Overview",
      icon: <PieChart />,
      permission: ["dashboard:read"],
    },
    {
      path: "/dashboard/lease-renewal",
      title: "Lease Renewal",
      icon: <EventRepeatOutlined />,
      permission: ["dashboard-leaserenewal:read"],
    }
  ]
}, {
  title: 'People',
  permission: ["leaderboard:read", "prospect:read", "tenant:read", "emailcontact:read"],
  children: [{
    title: 'Leaderboard',
    path: "/people/leaderboards",
    icon: <Award />,
    permission: ["leaderboard:read"]
  }, {
    title: 'Prospect',
    path: "/people/prospects",
    icon: <UserCheck />,
    permission: ["prospect:read"]
  }, {
    title: 'Tenant',
    path: "/people/tenants",
    icon: <User />,
    permission: ["tenant:read"]
  }, {
    title: 'Contacts',
    path: "/people/contacts",
    icon: <Send />,
    permission: ["emailcontact:read"]
  }]
}, {
  title: 'HR',
  permission: ["role:read", "user:read", "dashboard-usertimetracking:read"],
  children: [{
    title: 'Role',
    path: "/people/roles",
    icon: <ManageAccountsOutlined />,
    permission: ["role:read"]
  }, {
    title: 'Time Tracker',
    path: "/hr/user-time-tracker",
    icon: <AvTimerOutlined />,
    permission: ["dashboard-usertimetracking:read"]
  }, {
    title: 'Employees',
    path: "/hr/employees",
    icon: <Users />,
    permission: ["user:read"]
  }]
}, {
  title: 'Campaigns',
  permission: ["campaign:read", "campaign-group:read", "campaign-analytics:read", "campaign-renewaltemplate:read", "communityboard:read"],
  children: [{
    title: 'Manage Email Groups',
    path: "/communication/campaign-groups",
    icon: <Pocket />,
    permission: ["campaign-group:read"]
  }, {
    title: 'Manage Campaign',
    path: "/communication/campaigns",
    icon: <AtSign />,
    permission: ["campaign:read"]
  }, {
    title: 'Email Analytics',
    path: "/communication/analytics",
    icon: <BarChart2 />,
    permission: ["campaign-analytics:read"]
  }, {
    title: 'Renewal Offers',
    path: "/communication/renewal-offers",
    icon: <LocalOfferOutlined />,
    permission: ["campaign-renewaltemplate:read"]
  }, {
    title: 'Community Board',
    path: "/communication/community-boards",
    icon: <Flag />,
    permission: ["communityboard:read"]
  }]
}, {
  title: 'Request',
  permission: ["request:read", "complaint:read", "task:read"],
  children: [{
    title: 'Maintenance',
    path: "/maintenance/request",
    icon: <Tool />,
    permission: ["request:read"]
    // }, {
    //   title: 'Complaints',
    //   path: "/request/complaints",
    //   icon: <AssignmentLateOutlined />,
    //   permission: ["complaint:read"]
    // }, {
    //   title: 'Tasks',
    //   path: "/request/tasks",
    //   icon: <List />,
    //   permission: ["task:read"]
  }]
}, {
  title: 'Communication',
  permission: ["openhouse:read", "event:read", "prospect-taskaccount:read", "smschat:read", "emailnotification:read"],
  children: [{
    title: 'Schedule',
    path: "/schedule",
    icon: <Calendar />,
    permission: ["openhouse:read", "event:read", "prospect-taskaccount:read"]
  }, {
    title: 'Chat',
    path: "/chat",
    icon: <MessageSquare />,
    permission: ["smschat:read"]
  }, {
    title: 'Manage Notification',
    path: "/notification/email-sms-notification",
    icon: <Bell />,
    permission: ["emailnotification:read"]
  }]
}, {
  title: 'Operations',
  permission: ["lease:read"],
  children: [{
    title: 'Leases',
    path: "/leases",
    icon: <FileText />,
    permission: ["lease:read"]
  }]
}, {
  title: 'Income',
  permission: ["income:read", "income-category:read"],
  children: [{
    title: 'All Income',
    path: "/income/all-income",
    icon: <DollarSign />,
    permission: ["income:read"]
  }, {
    title: 'Income Category',
    path: "/income/income-category",
    icon: <Layers />,
    permission: ["income-category:read"]
  }]
}, {
  title: 'Expenses',
  permission: ["expense:read", "expense-payee:read", "expense-category:read"],
  children: [{
    title: 'All Expenses',
    path: "/expense/all-expense",
    icon: <CreditCard />,
    permission: ["expense:read"]
  }, {
    title: 'Manage Payee',
    path: "/expense/manage-payee",
    icon: <Sliders />,
    permission: ["expense-payee:read"]
  }, {
    title: 'Expense Category',
    path: "/expense/expense-category",
    icon: <Layers />,
    permission: ["expense-category:read"]
  }]
}, {
  title: 'Smart Devices',
  permission: ["device:read", "device-keyfob:read", "device-alert:read"],
  children: [{
    title: 'Manage Devices',
    path: "/smart-devices/list",
    icon: <Tablet />,
    permission: ["device:read"]
  }, {
    title: 'Manage Keyfob',
    path: "/smart-devices/keyfobs",
    icon: <Key />,
    permission: ["device-keyfob:read"]
  }, {
    path: "/smart-devices/iot-accounts",
    title: "Manage IoT Account",
    icon: <Zap />,
    permission: ["device:read"],
  }, {
    title: 'Device Alerts',
    path: "/smart-devices/alerts",
    icon: <Bell />,
    permission: ["device-alert:read"]
  }]
}, {
  title: 'Security',
  permission: ["vehicle:read", "journal:read"],
  children: [{
    title: 'Vehicles',
    path: "/security/vehicle/list",
    icon: <DirectionsCarFilledOutlined />,
    permission: ["vehicle:read"]
  }, {
    title: 'Journals',
    path: "/security/journal/list",
    icon: <AddModeratorOutlined />,
    permission: ["journal:read"]
  }]
}, {
  title: 'Pets',
  permission: ["pet:read"],
  children: [{
    title: 'Pets',
    path: "/pet/list",
    icon: <PetsOutlinedIcon />,
    permission: ["pet:read"]
  }]
}, {
  title: 'Resources',
  permission: ["knowledgebase:read", "knowledgebase-category:read"],
  children: [{
    title: 'Knowledge Base',
    path: "/resources/knowledge-bases",
    icon: <File />,
    permission: ["knowledgebase:read"]
  }, {
    title: 'Knowledge Base Category',
    path: "/resources/knowledge-base-categories",
    icon: <Folder />,
    permission: ["knowledgebase-category:read"]
  }]
}, {
  title: 'Reports',
  permission: ["report-rentroll:read", "report-pinata:read"],
  children: [{
    title: 'Rent Roll',
    path: "/reports/rentroll",
    icon: <Clipboard />,
    permission: ["report-rentroll:read"]
  }, {
    title: 'Pinata Report',
    path: "/reports/pinata",
    icon: <File />,
    permission: ["report-pinata:read"]
  }]
}, {
  title: 'Logs',
  permission: ["logs:read"],
  children: [{
    title: 'Logs',
    path: "/logs",
    icon: <Search />,
    permission: ["logs:read"]
  }]
}]